import React, { useEffect } from 'react';
import { HomePage } from './pages/HomePage';
import { MyStoryPage } from './pages/MyStoryPage';
import { ServicesPage } from './pages/ServicesPage';
import { ResultsPage } from './pages/ResultsPage';
import { ResourcesPage } from './pages/ResourcesPage';
import { ContactPage } from './pages/ContactPage';
import { BookedPage } from './pages/BookedPage';
import { pages } from './data/pages';
import { usePathname } from './hooks/usePathname';
import { EXTERNAL_REDIRECT, interceptLinkClicks, navigate } from './utils/router';
import { applyPageMeta } from './utils/seo';
export function App() {
  const pathname = usePathname();
  const meta = pages.find(page => page.path === pathname);
  useEffect(() => interceptLinkClicks(), []);
  useEffect(() => {
    // The browser is already leaving for another site (old blog post links).
    if (pathname === EXTERNAL_REDIRECT) return;
    // Unknown addresses fall back to the homepage URL.
    if (!meta) {
      navigate('/', {
        replace: true
      });
      return;
    }
    applyPageMeta(meta);
    const hash = window.location.hash;
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }
    // Jump links (e.g. /my-story#why-break-a-pencil) scroll to their section
    // once the page has rendered.
    const frame = requestAnimationFrame(() => {
      document.getElementById(decodeURIComponent(hash.slice(1)))?.scrollIntoView({
        block: 'start'
      });
    });
    return () => cancelAnimationFrame(frame);
  }, [pathname, meta]);
  if (pathname === EXTERNAL_REDIRECT) return null;
  switch (pathname) {
    case '/my-story':
      return <MyStoryPage data-id="element-0" data-mp="38kqcs5pvg9xu" />;
    case '/services':
      return <ServicesPage data-id="element-1" data-mp="38o4fxg6d0n6c" />;
    case '/results':
      return <ResultsPage data-id="element-2" data-mp="3dlw6a5rcw18f" />;
    case '/resources':
      return <ResourcesPage data-id="element-3" data-mp="3dii530ufhy2k" />;
    case '/contact':
      return <ContactPage data-id="element-4" data-mp="nuhicimzqbua" />;
    case '/booked':
      return <BookedPage data-id="element-5" data-mp="nxwvhfx3tat2" />;
    default:
      return <HomePage data-id="element-6" data-mp="studdqo0mp7y" />;
  }
}